/**************************** IMAGE UPLOAD ***************************************/
$( function() {
    $( "#CustomJacket" ).accordion({
      collapsible: true,
      heightStyle: "content"
    });
  });
  $(".gsrtd.btn").on('click',function() {
    $('html, body').animate({
      'scrollTop' : $(".PlusCustomForm").position().top
    });
  });
  $("#countries").msDropdown();
  $(".girlsImageForm").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.girlsImageForm').prop('files')[0];
      var imageName = $('.girlsImageForm').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.girlsImageForm').val().replace(/C:\\fakepath\\/i, '');
      
      
      ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/images/"+ne_get_1 ;
      var formData = new FormData($("#girlscustom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#girlscustom_form #girlsbar").show();
              $("#girlscustom_form #girlsbar").text("("+percentComplete+"%)");
              $("#girlscustom_form .girlsbar_wrapper_1").show();
              $("#girlscustom_form .girlsimageWrapp").css("display","none");
              $("#girlscustom_form .girlsmsg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("girlsbar").style.width=percentComplete+'%';
              document.getElementById("girlsbar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#girlscustom_form .girlsimageWrapp").css("display","none");
                $("#girlscustom_form .girlsmsg_uploading_1").html(imageName+" Image Uploaded");
                $("#girlscustom_form .girlsbar_wrapper_1.girlsprogress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#girlscustom_form .girlsImageForm").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
          $("#girlscustom_form").hide();
          $(".girlsImagesNames").html("<span>"+imageName+",</span>");
          $("#girlscustom_form_2").show();
        }
      })
    }
  })
  
  /************** 2nd Image ********************************/
  $(".girlsImageForm_2").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.girlsImageForm_2').prop('files')[0];
      var imageName = $('.girlsImageForm_2').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.girlsImageForm_2').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/images/"+ne_get_1 ;
      var formData = new FormData($("#custom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#girlscustom_form_2 #girlsbar_2").show();
              $("#girlscustom_form_2 #girlsbar_2").text("("+percentComplete+"%)");
              $("#girlscustom_form_2 .girlsbar_wrapper_1").show();
              $("#girlscustom_form_2 .girlsimageWrapp").css("display","none");
              $("#girlscustom_form_2 .girlsmsg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("girlsbar_2").style.width=percentComplete+'%';
              document.getElementById("girlsbar_2").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#girlscustom_form_2 .girlsimageWrapp").css("display","none");
                $("#girlscustom_form_2 .girlsmsg_uploading_1").html(imageName+" Image Uploaded");
                $("#girlscustom_form_2 .girlsbar_wrapper_1.girlsprogress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#girlscustom_form_2 .girlsImageForm_2").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
          $("#girlscustom_form_2").hide();
          $("<span>"+imageName+",</span>").appendTo(".girlsImagesNames");
          $("#girlscustom_form_3").show();
        }
      })
    }
  })   
  
  /************** 3rd Image ********************************/
  $(".girlsImageForm_3").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.girlsImageForm_3').prop('files')[0];
      var imageName = $('.girlsImageForm_3').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.girlsImageForm_3').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/images/"+ne_get_1 ;
      var formData = new FormData($("#girlscustom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#girlscustom_form_3 #girlsbar_3").show();
              $("#girlscustom_form_3 #girlsbar_3").text("("+percentComplete+"%)");
              $("#girlscustom_form_3 .girlsbar_wrapper_1").show();
              $("#girlscustom_form_3 .girlsimageWrapp").css("display","none");
              $("#girlscustom_form_3 .girlsmsg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("girlsbar_3").style.width=percentComplete+'%';
              document.getElementById("girlsbar_3").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#girlscustom_form_3 .girlsimageWrapp").css("display","none");
                $("#girlscustom_form_3 .girlsmsg_uploading_1").html(imageName+" Image Uploaded");
                $("#girlscustom_form_3 .girlsbar_wrapper_1.girlsprogress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#girlscustom_form_3 .girlsImageForm_3").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
          $("#girlscustom_form_3").hide();
          $("<span>"+imageName+",</span>").appendTo(".girlsImagesNames");
          $("#girlscustom_form_4").show();
        }
      })
    }
  })
  
  /************** 4th Image ********************************/
  $(".girlsImageForm_4").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.girlsImageForm_4').prop('files')[0];
      var imageName = $('.girlsImageForm_4').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.girlsImageForm_4').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/images/"+ne_get_1 ;
      var formData = new FormData($("#girlscustom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#girlscustom_form_4 #girlsbar_4").show();
              $("#girlscustom_form_4 #girlsbar_4").text("("+percentComplete+"%)");
              $("#girlscustom_form_4 .girlsbar_wrapper_1").show();
              $("#girlscustom_form_4 .girlsimageWrapp").css("display","none");
              $("#girlscustom_form_4 .girlsmsg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("girlsbar_4").style.width=percentComplete+'%';
              document.getElementById("girlsbar_4").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#girlscustom_form_4 .girlsimageWrapp").css("display","none");
                $("#girlscustom_form_4 .girlsmsg_uploading_1").html(imageName+" Image Uploaded");
                $("#girlscustom_form_4 .girlsbar_wrapper_1.girlsprogress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#girlscustom_form_4 .girlsImageForm_4").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
          $("#girlscustom_form_4").hide();
          $("<span>"+imageName+",</span>").appendTo(".girlsImagesNames");
          $("#girlscustom_form_5").show();
        }
      })
    }
  })
  
  /************** 5th Image ********************************/
  $(".girlsImageForm_5").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.girlsImageForm_5').prop('files')[0];
      var imageName = $('.girlsImageForm_5').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.girlsImageForm_5').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/images/"+ne_get_1 ;
      var formData = new FormData($("#girlscustom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#girlscustom_form_5 #girlsbar_5").show();
              $("#girlscustom_form_5 #girlsbar_5").text("("+percentComplete+"%)");
              $("#girlscustom_form_5 .girlsbar_wrapper_1").show();
              $("#girlscustom_form_5 .girlsimageWrapp").css("display","none");
              $("#girlscustom_form_5 .girlsmsg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("girlsbar_5").style.width=percentComplete+'%';
              document.getElementById("girlsbar_5").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#girlscustom_form_5 .girlsimageWrapp").css("display","none");
                $("#girlscustom_form_5 .girlsmsg_uploading_1").html(imageName+" Image Uploaded");
                $("#girlscustom_form_5 .girlsbar_wrapper_1.girlsprogress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#girlscustom_form_5 .girlsImageForm_5").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          $("<span>"+imageName+"</span>").appendTo(".girlsImagesNames");
          console.log("RIGHT SUBMIT");
          $("#girlscustom_form_5").addClass("StopUpload");
        }
      })
    }
  })
  
  
  /****************FORM SUBMIT *********************/
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  var OrderId = getCookie("OrderId");
  $(".hdrbg h3 b").html(OrderId);
  $(".girlsbtnGtsrtd button.form-btn.btn.btn-default").click(function(){
  
  
  
    var nameGet = $(".girlsNameForm").val();
    var emailGet = $(".girlsEmailForm").val();
    var numberGet = $(".girlsNumberForm").val();
    var selectGet = $("#countries").val();
    var ImageGet = $(".girlsImageForm").attr("data-src");
    var ImageGet_2 = $(".girlsImageForm_2").attr("data-src");
    var ImageGet_3 = $(".girlsImageForm_3").attr("data-src");
    var ImageGet_4 = $(".girlsImageForm_4").attr("data-src");
    var ImageGet_5 = $(".girlsImageForm_5").attr("data-src");
    var DescriptionGet = $(".girlsDescriptionForm").val();
  
  
    validateEmail(emailGet);
  
  
    function validateEmail(email) {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailReg.test(email)) {
        $("input.form-control.girlsEmailForm").css("border","1px solid red");
      }
      else if((emailGet=='')&&(nameGet=='')){
        $("input.form-control.girlsEmailForm").css("border","1px solid red");
        $("input.form-control.girlsNameForm").css("border","1px solid red");
      }
      else if((emailGet=='')||(nameGet=='')){
  
        if(emailGet==''){
          $("input.form-control.girlsEmailForm").css("border","1px solid red");
        }
        else{
          $("input.form-control.girlsNameForm").css("border","1px solid red");
        }
      }
  
        else {

        $(".RightWrap button.form-btn.btn.btn-default")
          .addClass("LoaderForm")
          .prop("disabled", true); // NEW: prevent double submits

        var OrderId = Math.floor((Math.random() * 10000000) + 1);
        $("input.form-control.girlsEmailForm").css("border","1px solid #cccccc");
        $("input.form-control.girlsNameForm").css("border","1px solid #cccccc");
        setCookie("OrderId", OrderId, 365);
        $.ajax({
          type: 'POST',
          url: 'https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-suede-jackets.php',
          data: {ImageGet:(ImageGet),ImageGet_2:(ImageGet_2),ImageGet_3:(ImageGet_3),ImageGet_4:(ImageGet_4),ImageGet_5:(ImageGet_5),OrderId:(OrderId),name:(nameGet),email:(emailGet),phone_number:(numberGet),want_to_make:(selectGet),description:(DescriptionGet)},
          dataType: 'html',
          success: function(response){

            window.location.href = "/pages/thank-you" ;
            var OrderId = getCookie("OrderId");
            $(".hdrbg h3 b").html(OrderId);
          },
          error: function(xhr, status, error) { // NEW: recover gracefully on failure
            $(".RightWrap button.form-btn.btn.btn-default")
              .removeClass("LoaderForm")
              .prop("disabled", false);
            alert("Something went wrong submitting your order. Please try again.");
          }
        })
      }
    }
  
  });